/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {useSelector} from 'react-redux'
import {Badge} from 'react-bootstrap';
import {StreamBankLink} from "../StreamBankLink";
import {useEditContextNodeId} from "../../../Hooks/PermissionHooks";

/**
 * Renders a context node (project or sub-program) row in a children list,
 * with an optional status badge.
 *
 * Props:
 *   item  — context node row from ContextNodeService (has contextNodeId, name, nicknames, link)
 *   badge — optional { variant, label, href? } for a trailing status badge. When href is
 *           set the badge is wrapped in a link to that survey/page; otherwise the badge
 *           is plain. Pass null (or omit) to render no badge.
 *
 * Nicknames may be comma-separated; only the first segment is shown so the list stays
 * readable when projects carry multiple aliases.
 */
export const EditableContextNodeListItem = props => {
	const {
		item,
		className = 'unordered',
		badge = null,
	} = props;

	const {tool = 'summary'} = useSelector(state => state.contextState.context);

	const canEditContextNodeId = useEditContextNodeId();
	const editable = canEditContextNodeId(item?.contextNodeId);

	const nickname = item?.nicknames ? item.nicknames.split(',')[0] : null;
	const name = item?.name + (nickname ? ` (${nickname})` : '');

	return <li key={item?.contextNodeId} className={className + (editable ? ' editable' : '') + (badge ? ' has-badge' : '')}>
		<StreamBankLink className="link-primary" Href={(item?.link ?? '') + '/' + tool}>{name}</StreamBankLink>
		{badge && (badge.href
			? <StreamBankLink Href={badge.href} className="ml-2">
				<Badge variant={badge.variant}>{badge.label}</Badge>
			  </StreamBankLink>
			: <Badge variant={badge.variant} className="ml-2">{badge.label}</Badge>
		)}
	</li>
}
